












import Vue from 'vue'
import Component from 'vue-class-component'
import Notification from './Notification.vue'

@Component({ components: { Notification } })
export default class NotificationBar extends Vue {
  visible: boolean = false
  options: any = null
  timeout: any

  get notificationColor () {
    return this.options.color
  }

  showNotification (options: any) {
    this.close()
    setTimeout(() => {
      this.options = options
      this.visible = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.close(), 5000)
    }, 50)
  }

  showSpecialNotification (options: any) {
    this.options = options
    this.options.special = true
    this.visible = true
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.close(), 60 * 1000)
  }

  close () {
    this.visible = false
    this.options = null
  }

  mounted () {
    this.$eventBus.$on('notify', this.showNotification)
    this.$eventBus.$on('notify-special', this.showSpecialNotification)
  }

  beforeDestroy () {
    this.$eventBus.$off('notify', this.showNotification)
    this.$eventBus.$on('notify-special', this.showSpecialNotification)
  }
}
